












import {
  defineNuxtComponent,
  onMounted,
  PropType
} from '~/utils/nuxt3-migration'
import { useModalToggle } from '~/compositions/modal-toggle'
import ClassifiedQuickSearchCategoryListMobile from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchCategoryListMobile.vue'
import { CategoryId } from '~/models/category/types'

export default defineNuxtComponent({
  components: {
    ClassifiedQuickSearchCategoryListMobile
  },
  props: {
    selectedSearchbarCategory: {
      type: Number as PropType<CategoryId>,
      required: true
    }
  },
  setup(_, { emit }) {
    const { setHash, modalOpen, modalClose } = useModalToggle(() =>
      emit('close-quick-search')
    )

    onMounted(() => {
      setHash('quick-search')
      modalOpen()
    })

    function closeMenu() {
      modalClose(false)
    }
    function removeModalClasses() {
      modalClose(false, true)
    }

    return {
      closeMenu,
      removeModalClasses
    }
  }
})
